<template>
  <section class="interactive">
    <div class="list">
       <ul class="list__dropdown">
        <li
          v-for="(item, key) in interactiveItems"
          :key="key"
          class="item"
          :class="{'item--active': key === active}"
          :data-key="key">
          <div
            @click="active = active === key ? false : key"
            class="item__top">
            <p
              class="title"
              v-html="item.title"></p>
            <button>
            </button>
          </div>
          <div class="item__description">
            <p
              class="description"
              v-html="item.description"></p>
          </div>
          <div
            class="item__image">
            <img :src="item.image.url" />
          </div>
        </li>
      </ul>
    </div>
    <div class="images">
      <div
        class="images__artwork"
        :style="`/* background-image:url('${artwork.url}') */`">
        <img :src="artwork.url" />
      </div>
      <ul
        class="images__list">
        <li
          v-for="(item, key) in interactiveItems"
          :key="key"
          class="item"
          :class="{'item--active': key === active}"
          :data-key="key">
          <div
            class="item__image">
              <img :src="item.image.url" />
            </div>
          </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InteractiveList',
  props: {
    items: {
      type: Array,
      default: null
    },
    artwork: {
      type: Object,
      default: null
    },
    ratio: {
      type: [ Number, String ],
      default: 1
    }
  },
  data() {
    return {
      active: null,
      itemActive: null,
      height: 400,
      resize: false
    }
  },
  computed: {
    interactiveItems: function() {
      return this.items.map(item => {
        item.active = false
        return item
      })
    }
  },
  methods: {
    updateActive($evt) {
      const key = $evt.target.getAttribute('data-key')

      // update active
      this.active = key
    },
    toggleInfo(note, state) {
      note.active = state
    }
  }
}
</script>

<style lang="scss" scoped>
.interactive {
  position:relative;
  display: flex;

  .list {
    width: 50%;
    &__dropdown {
      border-top: 2px solid #000;

      .item {
        border-bottom: 2px solid #000;

        &--active {
          color: #fff;
          background-color: #000;
          .item__top {
            button {
              &:before {
                background: #fff;
              }
              &:after {
                opacity: 0;
              }
            }
          }
          .item__description {
            height: unset;
            padding: 10px 10px;
          }
        }

        &__top {
          padding: 14px 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;

          button {
            @include button_resets;
            position: relative;
            height: 24px;
            width: 24px;
            &:before, &:after {
              content: '';
              width: 60%;
              height: 2px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(0deg);
              background: #000;
            }

            &:after {
              transform: translate(-50%, -50%) rotate(90deg);
            }
          }
        }

        &__description {
          height: 0px;
          overflow: hidden;
        }

        &__image {
          display: none;
        }
      }
    }
  }

  .images {
    width: 50%;
    position: relative;
    &__artwork {
      position: absolute;
      display: flex;
      justify-content: center;
    }

    &__list {
      display: relative;
      .item {
        position: absolute;
        top: 0px;
        left: 0px;
        opacity: 0;

        &--active {
          opacity: 1;
        }
      }
    }
  }

  @include mobile {
    flex-direction: column;
    .list {
      width: 100%;

      &__dropdown {

        .item {

          &__top {
            padding: 10px 5px;
          }

          &--active {
            color: #000;
            background-color: #fff;
            .item__top {
              button {
                &:before {
                  background: #000;
                }
                &:after {
                  opacity: 0;
                }
              }
            }
            .item__description {
              height: unset;
              padding: 10px 5px;
            }
            .item__image {
              display: block;
            }
          }
        }
      }
    }

    .images {
      display: none;
    }
  }
}
</style>
